var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "groupRules"
  }, [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', [_c('strong', [_vm._v(" Als... ")])]), _c('ol', {
    staticClass: "px-4 pt-4 mb-2"
  }, _vm._l(_vm.rules, function (rule, index) {
    return _c('li', {
      key: `group-rule-${index}`,
      staticClass: "group-rule"
    }, [_c('b-row', [_c('b-col', {
      staticClass: "d-flex flex-row col-12 align-items-center justify-content-between",
      attrs: {
        "cols": "12"
      }
    }, [_c('span', [_c('GroupRule', {
      attrs: {
        "rule": rule
      }
    }), index !== _vm.rules.length - 1 ? _c('span', [_vm._v(", en...")]) : _vm._e()], 1)]), _c('b-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('hr')])], 1)], 1);
  }), 0), _c('span', [_c('strong', [_vm._v(" ...dan wordt de order op hold gezet. ")])])])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }